import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "سباق الجائزة الكبرى السعودي يعود من جديد في الفترة من 18-20 أبريل 2025، ولكن هذه المرة في وقت لاحق من الموسم. استعدوا لأجواء أفضل، وغروب الشمس الساحر على الساحل، وسباقات ليلية أسرع تحت الأضواء الكاشفة."
      })
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "منذ انطلاقته في 2021، أصبح سباق جدة المفضل لدى الجماهير، مشهورة بسرعتها الفائقة، والمعارك المثيرة، والحلبة الرائعة التي تحاذي البحر الأحمر. 🔥 أسرع حلبة شوارع في الفورمولا 1 (سرعات متوسطة تزيد عن 250 كم/ساعة) 🏆 حيث تتقابل الأساطير، هل تتذكرون معركة فيرستابن وهاميلتون في 2021؟ 🌊 27 منعطفًا (أكثر عدد من المنعطفات في الفورمولا 1)، سباقات ليلية رائعة وإطلالات ساحلية"
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: ":عودة البطولة العالمية في 2025 فورمولا 1 هي قمة رياضة السيارات، حيث يتواجه أسرع السائقين في العالم عبر 24 جولة في مواقع شهيرة، من شوارع موناكو إلى صحاري السعودية وأضواء لاس فيغاس النيون. في 2025، القصة ستصبح أكبر مع"
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "تشكيلات جديدة للسائقين ✅"
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "تحديثات تقنية للسيارات ✅"
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "تزايد التنافس بين الفرق ✅"
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "واحد من أطول جداول السباقات في التاريخ ✅"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
